module.exports = __webpack_public_path__ + "img/icaro-claro.85d26965.png";